import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  typography: {
    fontFamily: ['Montserrat', 'Inter'].join(','),
  },
})

export default theme
